export default __webpack_public_path__ + "static/Web-camera-amazon-main-diagram-EN-5-de06c9429798782e6b697e99f07ffdfb.webp";